module.exports = __webpack_public_path__ + "assets/img/26_870.aa0ba468.jpg";